// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "d07818b572aa91865eeb6b72d8fc3b85" + ".js";
};